import {useState} from 'react'
import {Button} from 'antd'
import {Modal} from '@/components/Modal'
import {Table} from '@/components/Table'

const ButtonExport = ({suggestedName, table, ...props}) => {
    const onClick = () => table.exportAsXlsx({suggestedName})

    return (
        <Button
            {...props}
            onClick={onClick}
        >
            导出
        </Button>
    )
}

export default function ModalSheet({data, onOk, ...props}) {
    const [dataSource, setDataSource] = useState(data)
    const table = Table.useTable()

    const columns = 0 < data.length ?
        Object.keys(data[0]).map(k => ({
            dataIndex: k,
            dataType: 'longtext',
            title: k,
        }))
        :
        []

    const handleOk = () => onOk(dataSource)

    const buttonExport = (
        <ButtonExport
            table={table}
            suggestedName={`${props.title}.xlsx`}
        />
    )

    return (
        <Modal
            cancelText="关闭"
            height="90vh"
            leftButtons={buttonExport}
            width="90vw"
            onOk={handleOk}
            okText="保存"
            {...props}
        >
            <Table
                columns={columns}
                dataSource={dataSource}
                editable
                table={table}
                onChange={setDataSource}
            />
        </Modal>
    )
}
